<header>
  <div class="logo-header">
    <img
      src="assets/images/cbw-logo.png"
      alt="Camp Bow Wow logo"
      class="logo"
    >
  </div>
</header>
<div
  class="reg-body align-items-center"
  role="main"
>
  <div class="welcome-body-container body-container px-3">
    <header>
      <h1 class="page-title text-center">
        Welcome!
      </h1>
    </header>
    <p
      class="page-subtitle text-center mt-4"
      style="margin-bottom: 2.5rem;"
    >
      Whether you're new to Camp Bow Wow<sup>&#174;</sup> or just new to our app, we're excited to have you in our Pack.
      Let's get started!
    </p>
    <button
      class="btn btn-danger btn-block mx-auto"
      style="max-width: 20.625rem"
      (click)="navigateToRegisterPage()"
    >Continue</button>
    <div class="text-center mt-3">
      <span
        class="lato black"
        style="font-size: 0.75rem"
      >Already have an account? </span>
      <a
        class="link"
        routerLink="/sign-in"
        tabindex="0"
        (click)="navigateToSignInPage()"
      >Sign In</a>
    </div>
  </div>
  <app-privacy-policy-footer></app-privacy-policy-footer>
</div>